module.exports = __webpack_public_path__ + "static/media/alsoReadTextLeft.04215df4.svg";